export default{
    lista:{
        method:'get',
        url:'comissionado/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'comissionado/cadastro'
    },
    delete:{
        method:'delete',
        url:'comissionado/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'comissionado/editar{/id}'
    },
    update:{
        method:'post',
        url:'comissionado/update'
    }
}